export default __webpack_public_path__ + "2c0f6eadb97b6e6210c0aa2a5830822f.svg";